import React from 'react'
import { HorizontalSpacer, Icon, Link } from '@superhi/design'

const HS_1 = { small: 12, medium: 12, large: 16 }

type Config = {
  name: Extract<React.ComponentProps<typeof Icon>['name'], 'twitter' | 'facebook' | 'email'>
  href: string
}

type Props = { title: string; url: string }

const Share: React.FC<Props> = ({ title, url }) => {
  const shares = React.useMemo<Config[]>(
    () => [
      {
        name: 'facebook',
        href: `https://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`,
      },
      {
        name: 'twitter',
        href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          title,
        )}&url=${encodeURIComponent(url)}&related=superhi_`,
      },
      {
        name: 'email',
        href: `mailto:?subject=${encodeURIComponent(
          'Check out this post on SuperHi!',
        )}&body=${encodeURIComponent(url)}`,
      },
    ],
    [title, url],
  )

  return (
    <HorizontalSpacer data-component-name="Share" amount={HS_1}>
      {shares.map((share) => (
        <Link
          key={share.name}
          data-share-id={share.name}
          href={share.href}
          isExternal
          color="GREY_90"
          hoverColor="BLUE_50"
        >
          <Icon name={share.name} />
        </Link>
      ))}
    </HorizontalSpacer>
  )
}

export default Share
